"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiProviderJwt = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const provider_api_1 = require("@framework/provider-api");
const ApiProviderJwt = props => {
    const { baseUrl, storageName, children } = props;
    const { fetchJson } = (0, provider_api_1.useFetchJson)();
    const refreshToken = (0, react_1.useCallback)(async () => {
        const jwt = (0, provider_api_1.getToken)();
        if (!jwt) {
            return null;
        }
        try {
            const json = await fetchJson(`${baseUrl}/auth/refresh-token`, {
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json; charset=utf-8",
                }),
                credentials: "include",
                mode: "cors",
                method: "POST",
            });
            if (!json) {
                (0, provider_api_1.setToken)(null);
                return null;
            }
            (0, provider_api_1.setToken)(json);
            return json;
        }
        catch (e) {
            (0, provider_api_1.setToken)(null);
            throw e;
        }
    }, [baseUrl, fetchJson]);
    const getAuthToken = (0, react_1.useCallback)(() => {
        const jwt = (0, provider_api_1.getToken)();
        return jwt ? jwt.accessToken : "";
    }, []);
    return ((0, jsx_runtime_1.jsx)(provider_api_1.ApiProvider, { baseUrl: baseUrl, storageName: storageName, refreshToken: refreshToken, getAuthToken: getAuthToken, children: children }));
};
exports.ApiProviderJwt = ApiProviderJwt;
//# sourceMappingURL=provider.js.map